import { Component, Input } from '@angular/core'
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { Router, RouterLink } from '@angular/router'
import { emailValidator, FormInputComponent, UntypedFormComponent } from '@ftr/forms'
import {
  AlertComponent,
  AlertType,
  AnchorComponent,
  PageComponent,
  PageStyle,
  RemoteData,
  StackComponent,
} from '@ftr/foundation'
import { AppPaths } from '@ftr/routing-paths'
import { PortalBadgeComponent } from '@ftr/ui-site-portal'
import { ReplaySubject } from 'rxjs'
import { AuthenticationService, ResetAttributesService } from '../../services'

interface FormSubmission {
  email: string
}

@Component({
  selector: 'ftr-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.css'],
  host: {
    class: 'reset-request page',
  },
  imports: [
    AnchorComponent,
    RouterLink,
    FormInputComponent,
    UntypedFormComponent,
    AlertComponent,
    PageComponent,
    StackComponent,
    PortalBadgeComponent,
  ],
})
export class ResetComponent {
  resetForm: UntypedFormGroup
  submissionSubject = new ReplaySubject<RemoteData<void, string>>()
  submission = this.submissionSubject.asObservable()

  readonly alertTypes = AlertType
  readonly pageStyle = PageStyle.Narrow
  readonly loginPath = `/${AppPaths.Login}`

  @Input()
  showResetPasswordWarning: boolean

  constructor(
    formBuilder: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private readonly resetAttributesService: ResetAttributesService,
    private router: Router,
  ) {
    this.resetForm = formBuilder.group({
      email: ['', [Validators.required, emailValidator]],
    })
  }

  submitForm(value: FormSubmission): Promise<boolean> {
    this.resetAttributesService.email = value.email
    return this.authenticationService
      .resetPasswordSendVerification(value.email)
      .then(() => {
        return this.router.navigate(['/reset-sent'])
      })
      .catch(() => {
        // FTRX-218 All attempts are redirected
        return this.router.navigate(['/reset-sent'])
      })
  }

  asFormControl(control: AbstractControl): UntypedFormControl {
    return control as UntypedFormControl
  }
}
